"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIFlex;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FlexConstants = require("./FlexConstants");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-grow: 1;\n  align-items: ", ";\n  align-self: ", ";\n  flex-direction: ", ";\n  justify-content: ", ";\n  flex-wrap: ", ";\n  max-width: 100%;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFlex = _styledComponents.default.div.withConfig({
  displayName: "UIFlex__StyledFlex",
  componentId: "sc-19uxptt-0"
})(_templateObject(), function (props) {
  return _FlexConstants.ALIGN_OPTIONS[props.align];
}, function (props) {
  return _FlexConstants.ALIGN_SELF_OPTIONS[props.alignSelf];
}, function (props) {
  return _FlexConstants.DIRECTION_OPTIONS[props.direction];
}, function (props) {
  return _FlexConstants.JUSTIFY_OPTIONS[props.justify];
}, function (props) {
  return _FlexConstants.WRAP_OPTIONS[props.wrap];
});

function UIFlex(props) {
  var align = props.align,
      alignSelf = props.alignSelf,
      children = props.children,
      className = props.className,
      direction = props.direction,
      justify = props.justify,
      wrap = props.wrap,
      rest = (0, _objectWithoutProperties2.default)(props, ["align", "alignSelf", "children", "className", "direction", "justify", "wrap"]);
  return _react.default.createElement(StyledFlex, (0, _extends2.default)({}, rest, {
    align: align,
    alignSelf: alignSelf,
    className: (0, _classNames.default)('private-flex', className),
    direction: direction,
    justify: justify,
    wrap: wrap
  }), children);
}

UIFlex.propTypes = {
  align: _react.PropTypes.oneOf(Object.keys(_FlexConstants.ALIGN_OPTIONS)),
  alignSelf: _react.PropTypes.oneOf(Object.keys(_FlexConstants.ALIGN_SELF_OPTIONS)),
  children: _react.PropTypes.node.isRequired,
  direction: _react.PropTypes.oneOf(Object.keys(_FlexConstants.DIRECTION_OPTIONS)),
  justify: _react.PropTypes.oneOf(Object.keys(_FlexConstants.JUSTIFY_OPTIONS)),
  wrap: _react.PropTypes.oneOf(Object.keys(_FlexConstants.WRAP_OPTIONS))
};
UIFlex.defaultProps = {
  align: 'start',
  direction: 'row',
  justify: 'start',
  wrap: 'nowrap'
};
UIFlex.displayName = 'UIFlex';
module.exports = exports.default;